// src/api/useDeleteUser.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/api";

const resetAgenda = async (studyId) => {
  const params = new URLSearchParams();
  if (studyId) {
    params.append("studyId", studyId); // 'q'는 일반적으로 검색 쿼리를 나타내는 파라미터입니다.
  }
  return api.delete(`/agenda?${params.toString()}`);
};

export const useResetAgendaQuery = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: resetAgenda,
    onSuccess: () => {
      // 성공 시 users 쿼리 데이터를 무효화하여 최신 상태로 갱신합니다.
      queryClient.invalidateQueries(["agenda"]);
    },
  });
};
